import { calendarDriverFactory } from '../Calendar/Calendar.driver';
import { dropdownLayoutDriverFactory } from '../DropdownLayout/DropdownLayout.driver';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const calendarPanelDriverFactory = ({ element }) => {
  deprecationTestkitLog(
    'calendarPanelTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the CalendarPanelTestkit unidriver testkit instead.',
  );

  const dropdownLayoutElement = () =>
    element.querySelector('[data-hook=dropdown-layout]');
  const calendarElement = () => element.querySelector('[data-hook=calendar]');
  const getCalendarDriver = () =>
    calendarDriverFactory({ element: calendarElement() });
  const dropdownLayoutDriver = () =>
    dropdownLayoutDriverFactory({ element: dropdownLayoutElement() });

  const driver = {
    exists: () => !!element,
    calendarDriver: () => getCalendarDriver(),
    presetsDropdownLayoutDriver: () => dropdownLayoutDriver(),
    isDropdownExists: () => Boolean(dropdownLayoutElement()),
  };

  return driver;
};

export { calendarPanelDriverFactory };
